module.exports = __webpack_public_path__ + "img/bel.7bdd6295.svg";